export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class AbortError extends Error {
  constructor(message: string = 'Operation was aborted') {
    super(message);
    this.name = 'AbortError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AbortError);
    }
  }
}
